// src/components/EarnPointsItem.tsx
import React from 'react';
import {
  Facebook,
  Instagram,
  LinkedIn,
  Twitter,
  YouTube,
  Share,
  Email,
  Person,
  Check,
  ChevronRight,
  ShoppingBag,
  Cake,
} from '@mui/icons-material';
import { useSettings } from '../../../hooks/useSettings';

// Custom TikTok icon since it's not available in MUI
const TiktokIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V7.159a4.831 4.831 0 0 1-1.003-.479z"/>
  </svg>
);

interface EarnPointsItemProps {
  icon: string;
  title: string;
  subtitle: string;
  points: string;
  url?: string;
  isRedeemed?: boolean;
  onTap?: (url?: string) => void;
}

const EarnPointsItem: React.FC<EarnPointsItemProps> = ({ 
  icon, 
  title, 
  subtitle, 
  points, 
  url,
  isRedeemed = false, 
  onTap 
}) => {
  const getIcon = (iconName: string) => {
    const iconMap: { [key: string]: React.ReactNode } = {
      'facebook': <Facebook className="w-5 h-5" />,
      'instagram': <Instagram className="w-5 h-5" />,
      'tiktok': <TiktokIcon />,
      'linkedin': <LinkedIn className="w-5 h-5" />,
      'x-twitter': <Twitter className="w-5 h-5" />,
      'youtube': <YouTube className="w-5 h-5" />,
      'share': <Share className="w-5 h-5" />,
      'envelope': <Email className="w-5 h-5" />,
      'user': <Person className="w-5 h-5" />,
      'shopping-bag': <ShoppingBag className="w-5 h-5" />,
      'gift': <Cake className="w-5 h-5" />,
    };
    return iconMap[iconName] || <Person className="w-5 h-5" />;
  };

  const baseClasses = "bg-gray-50 rounded-xl transition-all duration-300 my-1";
  const interactiveClasses = isRedeemed 
    ? "opacity-60" 
    : "hover:bg-gray-100 cursor-pointer";

  const iconContainerClasses = `w-10 h-10 rounded-lg flex items-center justify-center mr-3 ${
    isRedeemed 
      ? "bg-gray-200" 
      : "bg-blue-50"
  }`;

    const { settings, getSetting } = useSettings();
  const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
  const hoverColor = getSetting('widget_hover_color', process.env.REACT_APP_PRIMARY_COLOR_HOVER || '#2563EB');

  const iconClasses = isRedeemed ? "text-gray-500" : "text-black";

  const textClasses = isRedeemed ? "text-gray-500" : "text-black";
  
  const badgeClasses = `px-3 py-1 rounded-2xl flex items-center gap-1 ${
    isRedeemed 
      ? "bg-gray-200" 
      : "bg-gray-100"
  }`;

const badgeTextClasses = `text-xs font-semibold ${
  isRedeemed ? "text-gray-500" : "text-${primaryColor}" 
}`;

  const chevronClasses = `w-4 h-4 ${
    isRedeemed ? "text-gray-500" : "text-black"
  }`;

    const handleClick = () => {
    if (!isRedeemed && onTap) {
      onTap(url);
    }
  };

  return (
    <div className={`${baseClasses} ${interactiveClasses}`}>
      <div 
        className="p-4"
        onClick={handleClick}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center flex-1">
            <div className={iconContainerClasses}>
              <div className={iconClasses}>
                {getIcon(icon)}
              </div>
            </div>
            <div className="flex-1">
              <div className={`font-medium text-sm ${textClasses}`}>
                {title}
              </div>
              {subtitle && (
                <div className={`font-medium text-base ${textClasses}`}>
                  {subtitle}
                </div>
              )}
            </div>
          </div>
          
          <div className="flex items-center gap-3">
             {isRedeemed ? '' :
             
            <div className={badgeClasses}> 
              {/* {isRedeemed && (
                <Check className="w-3 h-3 text-gray-500" />
              )} */}
              <span className={badgeTextClasses} style={!isRedeemed ? { color: primaryColor } : undefined}>
                {isRedeemed ? '' : points}
              </span>
             </div> }
            <ChevronRight className={chevronClasses} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarnPointsItem;